import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { SplashScreen as CapSplashScreen } from '@capacitor/splash-screen';
import { isNativeApp, isBusinessApp } from '../../utils/platform';

// Animated Petzy launch splash — native only.
//
// The static iOS LaunchScreen (same ink background + monogram) covers the
// pre-React load. With `launchAutoHide: false` (capacitor.config.json) it stays
// up until we hide it here, AFTER this identical overlay has painted — so the
// handoff is seamless, no white flash. Then the mark + wordmark animate in, the
// overlay holds briefly, and AnimatePresence fades it out to reveal the app.
// Web never mounts this.
const HOLD_MS = 1400;
const INK = '#221D18';

export default function SplashScreen() {
  const [show, setShow] = useState(isNativeApp);

  useEffect(() => {
    if (!isNativeApp) return undefined;
    CapSplashScreen.hide().catch(() => {});
    const timer = setTimeout(() => setShow(false), HOLD_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!isNativeApp) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[200] flex items-center justify-center"
          style={{ backgroundColor: INK }}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: 'easeOut' }}
        >
          <motion.span
            className="font-display text-6xl font-bold tracking-tight text-cream-50"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          >
            {/* Same wordmark, but the Business binary marks itself so the two
                native apps are visually distinct at launch. Colors/timing are
                unchanged — only the trailing label differs. */}
            petzy<span className="text-primary-400">.</span>
            {isBusinessApp && (
              <span className="ml-2 align-middle text-2xl font-semibold tracking-normal text-primary-400">
                Business
              </span>
            )}
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
